export const comments_4791871 = {"data":{"data":[],"links":{}}}